<template>
  <div class="bg-img width-100 padding-Tb-20 flex-column justify-content-spaceBetween align-items-star">
    <img src="../../../assets/image/yfns/18.png" width="100%" alt="" />
    <div class="box position-relative width-100 flex-column justify-content-start align-items-center">
      <div class="width-90 main br-reg van-overflow-hidden flex-column justify-content-start align-items-center">
        <van-form class="width-100" @submit="onSubmit">
          <van-cell-group class="border-b" inset>
            <van-field
              class="border-b margin-b"
              v-model="username"
              name="姓名"
              label="您的姓名"
              placeholder="请填写您的姓名"
              :readonly="hasInfo"
              :rules="[{ required: true }]"
            />
            <van-field
              class=""
              v-model="mobile"
              name="手机号码"
              label="联系方式"
              placeholder="请填写您的手机号码"
              :readonly="hasInfo"
              :rules="[{ validator: mobileValidator, message: '请填写正确的手机号码' }]"
            />
          </van-cell-group>
          <p class="width-100 padding-lr fs-sml greyBlue textAlign-c">提示：填写信息后才能参与抽奖哦</p>
          <div class="position-relative" style="margin: 16px 16px">
            <van-button class="opacity-0 zIndex" round block type="primary" color="#349AFC" native-type="submit"> 立即领取 </van-button>
            <img class="position-absolute" style="left: 22.5%; top: 0" src="../../../assets/image/yfns/21.png" width="55%" alt="" />
          </div>
        </van-form>
      </div>
      <img class="image position-absolute" src="../../../assets/image/yfns/13.png" width="30%" alt="" />
    </div>
    <img src="../../../assets/image/yfns/8.png" class="margin-t" width="100%" alt="" />
    <!--    规则-->
    <img class="fixed-right" @click="showRule = true" src="../../../assets/image/yfns/6.png" width="6%" alt="" />
    <van-popup v-model="showRule" class="width-85 popup-box">
      <img src="../../../assets/image/yfns/19.png" width="100%" alt="" />
    </van-popup>
  </div>
</template>

<script>
import { userInfo, wxRaffle } from '@/api/act/yfnsApi';
import { Toast, Dialog } from 'vant';

export default {
  name: '',
  components: {},
  data() {
    return {
      wxId: '',
      username: '',
      mobile: '',
      showRule: false,
      hasInfo: false
    };
  },
  created() {
    this.wxId = sessionStorage.getItem('wxId');
    userInfo({ wxId: this.wxId }).then((res) => {
      if (res.code === 0 && res.data) {
        this.username = res.data.nickName;
        this.mobile = res.data.mobile;
        this.hasInfo = true;
      }
    });
  },
  mounted() {},
  methods: {
    mobileValidator(val) {
      return /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(val);
    },
    onSubmit() {
      console.log(this.wxId);
      wxRaffle({ name: this.username, mobile: this.mobile, wxId: this.wxId }).then((res) => {
        if (res.code === 0) {
          this.$router.replace('cj');
        } else if (res.code === 409) {
          Dialog.alert({
            title: '提示',
            message: '您已中过奖品，点击确认前往查看奖品'
          }).then(() => {
            this.$router.replace('cj');
          });
        } else {
          Toast.fail(res.msg);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import '../../../assets/css/yfns/common.css';
@import '../../../assets/css/yfns/demo1.css';
@import '../../../assets/css/yfns/demo2.css';
.bg-img {
  min-height: 100vh;
  background: rgb(56, 162, 77) url('../../../assets/image/yfns/bg1.jpg') round no-repeat;
  background-size: 100%;
}
.box {
  background: url('../../../assets/image/yfns/5.png') no-repeat bottom center;
  background-size: 100%;
  height: 400px;
  margin-bottom: 60px;
  .image {
    left: -5%;
    bottom: -100px;
  }
}
.main {
  padding: 140px 0 40px;
}
/deep/.van-cell::after {
  border-bottom: none;
}
/deep/.van-popup {
  background: rgba(0, 0, 0, 0);
}
/deep/.van-cell-group {
  background: rgba(0, 0, 0, 0);
}
/deep/.van-cell::after,
/deep/.van-cell-group,
/deep/.van-hairline--top-bottom::after {
  border-bottom: none;
}
/deep/.van-cell {
  background-color: rgba(0, 0, 0, 0);
  padding: 0 16px;
}
/deep/.van-field__label {
  width: 4rem;
  padding: 10px 0;
  color: #333333;
  font-weight: bold;
}
/deep/.van-cell__value {
  border-radius: 10px;
  background-color: #ffffff;
  padding: 10px 16px;
}
</style>
